import React from 'react';
import {
  ForgeAppBar,
  ForgeButton,
  ForgeIcon,
  ForgeScaffold,
} from '@tylertech/forge-react';
import { useNavigate } from 'react-router';
import ImageContainer from '../../reusable/ImageContainer.js';
import ForgeStack from '../../reusable/ForgeStack/ForgeStack.js';
import { SIGN_IN } from '../../../static/keyWords.js';
import './SessionEnded.scss';
import { SESSION_ENDED } from '../../../static/constants.js';
import { messageManager } from '../messageManager/messageManager.js';
import { NAVIGATION_PATHS } from '../../../static/navigationPaths.js';
import { useNameConventions } from '../../../contexts/nameConventionsContext.js';
import {
  canAttemptSilentAuthentication,
  startSilentAuthentication,
} from '../../../services/ssoService.js';

const SessionEnded = () => {
  const { nameConventions } = useNameConventions();
  const navigate = useNavigate();

  const handleSignIn = () => {
    if (canAttemptSilentAuthentication()) {
      startSilentAuthentication('/');
      return;
    }

    navigate(NAVIGATION_PATHS.LOGIN);
  };

  return (
    <>
      <ForgeScaffold>
        <ForgeAppBar
          title-text="Priority Based Budgeting"
          theme-mode="scoped"
          slot="header"
        >
          <ForgeIcon slot="logo" name="tyler_talking_t_logo" />
        </ForgeAppBar>
        <ForgeStack slot="body" justify="center" alignment="center">
          <ImageContainer
            slot="graphic"
            source={SESSION_ENDED.source}
            alt={SESSION_ENDED.alt}
            customClasses={'session-ended-graphic'}
          />
          <div className="forge-typography--heading5 opacity54">
            {messageManager(nameConventions).SESSION_ENDED.TITLE}
          </div>
          <p className="forge-typography--body2">
            {messageManager(nameConventions).SESSION_ENDED.MESSAGE}
          </p>
          <ForgeButton
            variant="raised"
            slot="action"
            onClick={handleSignIn}
          >
            {SIGN_IN}
          </ForgeButton>
        </ForgeStack>
      </ForgeScaffold>
    </>
  );
};

export default SessionEnded;
